import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      pointerEvents: 'auto',
    },
    root: {
      width: 'auto',
      height: '32px',
      backgroundColor: '#001D29',
      color: '#FFFFFF',
      borderRadius: '4px',
      padding: '18px 16px',
      gap: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '1.2',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',

      '&:hover': {
        backgroundColor: '#002A3A',
        boxShadow: '0 4px 8px rgba(0, 29, 41, 0.3)',
      },

      '&:active': {
        backgroundColor: '#001A23',
        transform: 'translateY(1px)',
      },

      '& .MuiButton-startIcon': {
        marginRight: '8px',
        marginLeft: 0,
      },

      '& .MuiButton-label': {
        textDecoration: 'none',
        color: '#FFFFFF',
        textAlign: 'center',
      },
    },
  }),
)
